import { Injectable, NgZone } from '@angular/core';
import { DBService } from 'src/app/services/db.service';
import { UtilService } from 'src/app/services/util.service';
import { LoadingController, ModalController, Platform, AlertController } from '@ionic/angular';
//import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { UserService } from 'src/app/services/user.service';
import { WifiService } from 'src/app/services/wifi.service';
import { Table } from 'src/app/models/table.model';
import { OrderGroup, Order } from 'src/app/models/order.model';
import { QRScanInfoComponent } from 'src/app/components/qrscan-info/qrscan-info.component';
import { PermissionDescrComponent } from 'src/app/components/permission-descr/permission-descr.component';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
import { TWENTY_SEC, ANALYTICS_EV_ORDER_ERROR, ANALYTICS_EV_CAPTCHA_ERROR } from 'src/environments/constant';
import { BonuskarteService } from './bonuskarte.service';
import { Router } from '@angular/router';
import { Events } from 'src/app/services/events.service';
import { PushService } from 'src/app/services/push.service';

const WITHOUT_GPS: boolean = false;
declare var grecaptcha;

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private isHuman: boolean = false

  private router: Router

  constructor(public diagnostic: Diagnostic, public db: DBService, public util: UtilService, private events: Events, private ngZone: NgZone, private modalController: ModalController, private bonuskartenService: BonuskarteService,
    private userService: UserService, private wifiService: WifiService, private loadingController: LoadingController, private platform: Platform, private alertCtrl: AlertController,
    private pushService: PushService) { 
      this.requestCaptcha()
    }

  /**
   * Sollte immer in den init Methoden aufgerufen werden
   * @param _router 
   */
  public initRouter(_router: Router) {
    this.router = _router;
  }

  /**
   * Click auf Button in UI
   */
  clickOnOrderNow(orderGroup: OrderGroup = null) {
    this.util.debug('clickOnOrderNow', orderGroup)
    if (this.util.demo) {
      if (this.userService.currentTable && this.userService.currentTable.name) orderGroup.source = this.userService.currentTable.name
      else orderGroup.source = 'DEMO TISCH'
      this.askIsSure2Order(orderGroup)//TODOxxxxxxxxx
      return
    }

    if (!this.db.currentRestaurant.isOpen) {
      let toastText = 'Leider hat das Lokal aktuell geschlossen.'
      if (!orderGroup.isService) toastText += ' Du kannst deinen Warenkorb für später speichern.'
      this.util.presentToast(toastText, 3000, 'toast-warning')
      return
    }

    if (this.util.isMobileApp2 && !this.db.currentRestaurant.phoneValidation)
      this.wifiService.enableWifi(WITHOUT_GPS);

    this.util.debug('Selected table', this.userService.currentTable)
    if (this.userService.currentTable) { //Falls er bereits einen Tisch hat, geht es weiter mit der Frage, ob er sicher ist
      orderGroup.source = this.userService.currentTable.name
      this.askIsSure2Order(orderGroup)
    } else {
      //*** Wenn noch kein Tisch gewählt wurde, muss erst einmal der Tisch gewaehlt werden ***//
      this.selectTableViaQRCode(orderGroup);
    }
  }



  //  !inclusiveOrdern  = wenn es nur Tisch Wechsel ist...
  public async selectTableViaQRCode(orderGroup: OrderGroup) {
    //if it is via web, ask directly for table number
    if(!this.util.isMobileApp2){
      this.enterTableNoManually(orderGroup)
      return
    }

    //1. Show him the image, how it works
    const modal = await this.modalController.create({
      component: QRScanInfoComponent
    });

    await modal.present();
    await modal.onDidDismiss().then((barcodeData: any) => {

      this.util.isModalOpen = false

      if (barcodeData.data) {
        this.checkTableNoEntry(orderGroup, barcodeData.data)
      } else {
        this.enterTableNoManually(orderGroup)
      }
    })
  }

  async enterTableNoManually(orderGroup: OrderGroup) {
    const alert = await this.alertCtrl.create({
      header: 'Tischnummer manuell eingeben',
      message: 'Du kannst die Tischnummer des Aufstellers hier eingeben',
      cssClass: 'myAlert',
      inputs: [
        {
          name: 'tablenumber',
          type: 'number',
          placeholder: ''
        }
      ],
      buttons: [
        {
          text: 'Abbrechen',
          cssClass: 'alert-button',
          role: 'cancel',
          handler: () => {
            this.util.presentToast('Tisch-Code konnte nicht eingelesen werden.', 3000, 'toast-warning')
          }
        }, {
          text: 'OK',
          cssClass: 'alert-button',
          handler: (data) => {
            this.checkTableNoEntry(orderGroup, data.tablenumber);
          }
        }
      ]
    });
    await alert.present();

    let elements: any = document.getElementsByClassName("alert-input")
    if (elements && elements.length > 0) {
      for (let element of elements) {
        element.autofocus = true;
        element.focus()
      }
    }
  }

  private checkTableNoEntry(orderGroup: OrderGroup, tableNo) {
    //********************************************** */
    // Optionally request the permission early
    //this.qrScanner.scan().then(barcodeData => {
    if (tableNo) { // text: "...", format: "QR_CODE"
      if (this.db.currentRestaurant.tables.find((table: Table) => table.qrCode === tableNo) === undefined) {
        this.util.presentToast('Eingegebener Tisch-Code wurde nicht gefunden.', 3000, 'toast-warning')
        return
      }

      this.userService.currentTable = this.db.currentRestaurant.tables.find((table: Table) => table.qrCode === tableNo)
      this.util.presentToast('Tisch erfolgreich erfasst.', 2000, 'toast-success')

      if (orderGroup) {
        orderGroup.source = this.userService.currentTable.name
        this.askIsSure2Order(orderGroup)
      }
    } else {
      this.util.presentToast('QR-Code des Tisches konnte nicht eingelesen werden.', 3000, 'toast-warning')
    }
    //********************************************** */
  }


  currentService: OrderGroup = undefined
  private askIsSure2Order(orderGroup: OrderGroup) {
    //Falls einfach SMS Telefonnumerverifizierung reicht...
    if(this.db.currentRestaurant.phoneValidation){
      if(orderGroup.isService) this.currentService = orderGroup
      this.ngZone.run(() => this.router.navigate(['/eat-outside']))
    }else{



      let data: any[] = [];
      this.util.debug('iOS Order askIsSure2Order', orderGroup)
      if (!orderGroup.isService) {
        data.push(this.util.formatPrice(this.db.getBasketPrice()));
        data.push(orderGroup.source)
  
        //todo formatierung im popup
        if (!this.wifiService.isInRestaurant(this.db.currentRestaurant.wifi2)) {
          data.push("Um sicherzustellen, dass Bestellungen nur innerhalb des Lokals getätigt werden, erteile uns bitte im nächsten Schritt deine Standort-Berechtigung.");
        }
  
        //Falls es kein Service ist
        this.util.popup('red', data, 'sureForYorOder', -1)
        this.events.unsubscribe('sureForYorOder-' + this.util.timeWhenSureForYorOder)
        this.util.timeWhenSureForYorOder = new Date().getTime()
  
        this.events.subscribe('sureForYorOder-' + this.util.timeWhenSureForYorOder, (res) => {
          if (res && res.data === true) {
            this.orderBasket(orderGroup);
            this.events.unsubscribe('sureForYorOder-' + this.util.timeWhenSureForYorOder)
          } else if (res && res.data === 'changeTable') {
            this.events.unsubscribe('sureForYorOder-' + this.util.timeWhenSureForYorOder)
            this.selectTableViaQRCode(orderGroup);
          }
        });
      } else {
        //Falls es ein Service ist
        let serviceName: string = (orderGroup.order && orderGroup.order.length == 1) ? orderGroup.order[0].fixedItemName : ' ? '
        //todo formatierung im popup
        data.push(serviceName);
        data.push(orderGroup.source)
  
        if (!this.util.isIOS() && !this.wifiService.isInRestaurant(this.db.currentRestaurant.wifi2)) {
          data.push("Um das Lokal zu verifizieren, erteile uns bitte im nächsten Schritt deine Standort-Berechtigung.");
        }
  
        if (this.util.isIOS()) {
          data.push("Du musst mit dem WLAN des Lokals verbunden sein. Das kannst du im nächsten Schritt automatisiert durchführen.");
        }
  
        this.util.popup('red', data, 'sureCallingService', -1)
        this.events.unsubscribe('sureCallingService-' + this.util.timeWhenSureCallingService)
        this.util.timeWhenSureCallingService = new Date().getTime()
  
        this.events.subscribe('sureCallingService-' + this.util.timeWhenSureCallingService, (res) => {
          if (res && res.data === true) {
            orderGroup.paid = true    //Default for Service
            orderGroup.getippt = true //Default for Service
            this.orderBasket(orderGroup);
            this.events.unsubscribe('sureCallingService-' + this.util.timeWhenSureCallingService)
          }
        });
      }


    }
  }


  //das hier ist die main function wenn bestellt wird...
  orderBasket(orderGroup: OrderGroup) {
    //*** Check, ob er sich aktuell im Restaurant befindet ***/
    if (this.util.demo) {
      this.finallyOrder(orderGroup)
    } else {
      this.util.debug('iOS Order in orderBasket', orderGroup)
      this.askRealPermissions(orderGroup, true);
    }
  }

  checkIOSLocation(orderGroup: OrderGroup) {
    this.util.debug('iOS Order in checkIOSLocation', orderGroup)

    this.wifiService.getConnectedBSSID().then(bssid => {
      this.util.debug('iOS Order getConnectedBSSID', bssid)
      //Mit iergendeinem Netzwerk verbunden
      if (this.wifiService.isBSSIDInRestaurant(bssid, this.db.currentRestaurant.wifi2)) {
        this.util.debug('iOS Order isBSSIDInRestaurant TRUE', this.db.currentRestaurant.wifi2)
        this.finallyOrder(orderGroup)
      } else {
        this.util.debug('iOS Order isBSSIDInRestaurant FALSE', this.db.currentRestaurant.wifi2)
        //Mit eigentlichem Restaurant verbinden
        this.connect2WIFIs(orderGroup)
      }
    }, err => {
      this.util.debug('iOS Order getConnectedBSSID ERR', err)

      //Mit keinem Netzwerk verbunden
      this.connect2WIFIs(orderGroup);
    })
  }

  connect2WIFIs(orderGroup: OrderGroup) {
    let wifis: any[] = this.db.currentRestaurant.wifi2 ? this.db.currentRestaurant.wifi2 : []
    let foundWifi: any = undefined
    for (let wifi of wifis) {
      if (wifi.password && wifi.password.length > 0) {
        foundWifi = wifi
        break; //TODO: Hier nimmt er nur das erste was er findet
      }
    }


    this.util.debug('iOS Order connect2WIFIs foundWifi?', foundWifi, wifis)

    if (foundWifi) {
      this.wifiService.iOSConnectNetwork(foundWifi.ssid, foundWifi.password.length > 1 ? foundWifi.password : '').then(val => {
        this.util.debug('iOS Order connect2WIFIs iOSConnectNetwork val', val)
        this.util.presentToast("Erfolgreich verbunden", 3000, 'toast-success')
        setTimeout(() => {
          this.wifiService.getConnectedBSSID().then(bssid => {
            if (this.wifiService.isBSSIDInRestaurant(bssid, this.db.currentRestaurant.wifi2)) {
              setTimeout(() => {
                this.finallyOrder(orderGroup)
              }, 2500)
            } else {
              this.util.presentToast('Da hat etwas nicht geklappt. Versuche es noch einmal.', 3500, 'toast-warning')
            }
          }, err => {
            this.util.presentToast('Da hat etwas nicht geklappt. Versuche es noch einmal.', 3500, 'toast-warning')
          })
        }, 1500);
      }, err => {
        this.util.debug('iOS Order connect2WIFIs foundWifi ERR', err)
        this.util.presentToast('Leider ist das WLAN des Lokals nicht erreichbar. Die Bestellung kann nicht gesendet werden.', 3500, 'toast-warning')
      })
    } else {
      this.util.presentToast('Es wurde kein WLAN des Lokals gefunden.', 3500, 'toast-warning')
    }

  }

  async askRealPermissions(orderGroup: OrderGroup, isImportant: boolean) {
    if (this.util.isIOS()) {
      this.checkIOSLocation(orderGroup);

      return
    }

    this.db.sendLog('askRealPermission')

    if (!this.wifiService.newScanRequired()) {
      //Kein neuer Scan
      this.util.error("yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy")
      this.util.error("yyyyyyyyNO SCREEN yyyyyyyyyyyyyy")
      this.util.error("yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy")

      if (this.wifiService.isInRestaurant(this.db.currentRestaurant.wifi2)) {
        this.loadingController.dismiss()
        this.finallyOrder(orderGroup)
        return
      } else if (!isImportant) { //Wenn es nicht wichtig ist, entsprechende Fehlermeldung anzeigen
        this.checkLocation(orderGroup)
        return
      }
    }

    this.wifiService.networks = []


    //Callback Function
    this.events.unsubscribe('allpermissionsgranted'); //Erstmal alle loeschen
    this.events.subscribe('allpermissionsgranted', (res) => {
      this.db.sendLog('allpermissionsgranted Event')

      this.diagnostic.isLocationAuthorized().then((authorized) => {
        if (authorized) {
          this.wifiService.lastWifiScanTS = new Date().getTime()

          this.events.subscribe('networkdetected', (res) => {
            this.events.unsubscribe('networkdetected')
            this.checkLocation(orderGroup)
          })

          this.activateLoadingController();
          this.wifiService.initStartWifiScreening(false);
        }
        else {
          this.showPermissionInformation(orderGroup);
        }
      })

      this.events.unsubscribe('allpermissionsgranted'); //Erstmal alle loeschen
    });

    this.wifiService.enableLocalLocationAppPermission()
  }

  private checkLocation(orderGroup: OrderGroup) {
    if (this.wifiService.isInRestaurant(this.db.currentRestaurant.wifi2)) {
      this.loadingController.dismiss()
      this.finallyOrder(orderGroup)
    } else {
      if (!this.wifiService.allPreconditionsFullfilled()) { //Wenn keine Netzwerke sichtbar sind, hat er sehr wahrscheinlich wieder keine Berechtgung gegeben
        //*************************************************************** */
        this.loadingController.dismiss()
        this.showPermissionInformation(orderGroup); //sollte eigentlich nicht hierher ausser es ist wirklich kein WLAN in Reichweite
        //*************************************************************** */
      } else {
        this.loadingController.dismiss()
        //Wenn er nach dem Dialog die Berechtigung erteilt hat, aber nicht im Restaurant ist...
        this.util.presentToast('Leider konnten wir nicht festellen, dass du dich aktuell in dem Lokal aufhälst', 4000, 'toast-warning')
      }
    }
  }

  private async showPermissionInformation(orderGroup: OrderGroup) {
    const modal = await this.modalController.create({
      component: PermissionDescrComponent
    });

    await modal.present();
    await modal.onDidDismiss().then((response: any) => {
      this.util.isModalOpen = false
      if (response.data === true) {
        this.askRealPermissions(orderGroup, true)
      } else {
        this.util.presentToast('Leider steht dir die Bestell-Funktion ohne die Berechtigungsfreigabe nicht zur Verfügung. Wir bitten um dein Verständnis.', 5000, 'toast-warning')
      }
    })
  }

  lastTimeIsNo
  public async finallyOrder(_orderGroup: OrderGroup, paypal: boolean = false) {
    let orderDone: boolean = false
    
    const loading = await this.loadingController.create({
      message: 'Bestellung wird gesendet. Ihr Smartphone benötigt dafür eine Internetverbindung.',
      duration: (TWENTY_SEC + 1000)
    });
    loading.present();

    this.events.subscribe('orderSent', (updatedOrderGroup: any) => {
      orderDone = true
      this.bonuskartenService.markUsedOrders(updatedOrderGroup.orderGroup);
      
      if(!paypal){
        this.events.unsubscribe('orderSent')
        this.util.popup('green', '', 'thxForYourOrder')
        this.db.setPage('home')
        // this.ngZone.run(() => this.router.navigate(['/customer-home']))  //Doch nicht zu meinen Bestellungen zurueckkehren
        this.ngZone.run(() => this.router.navigate(['/order']))  //Doch nicht zu meinen Bestellungen zurueckkehren
        loading.dismiss()
      }

    })

    setTimeout(() => {
      if(!orderDone) {
        this.util.presentToast("Leider hat etwas nicht geklappt - bitte prüfe deine Internetverbindung.", 4500, "toast-warning")
        this.db.addAnalytics(ANALYTICS_EV_ORDER_ERROR)
      }
    }, (TWENTY_SEC + 2000))

    if(this.isHuman == true){
      this.db.orderBasket(_orderGroup, paypal);
    }else{
      this.events.subscribe('captchaVerified', () => {
        this.events.unsubscribe('captchaVerified')
        this.db.orderBasket(_orderGroup, paypal);
      })
      this.requestCaptcha()
    }
  }

  async activateLoadingController() {
    const loading = await this.loadingController.create({
      message: 'Lokal wird lokalisiert...',
      duration: 10000
    });
    loading.present();
  }

  private back(pageComponent: string = 'home') {
    this.db.setPage(pageComponent)
    if (this.db.loggedUserUID && (this.db.isOwner || this.db.isEmployee)) {
      this.ngZone.run(() => this.router.navigate(['/owner-home']))
    } else this.ngZone.run(() => this.router.navigate(['/customer-home']))

  }

  askOwner4RealPermissions() {
    //Callback Function
    this.events.unsubscribe('allpermissionsgranted'); //Erstmal alle loeschen
    this.events.subscribe('allpermissionsgranted', (res) => {
      this.wifiService.initStartWifiScreening();

      this.activateLoadingController();
      setTimeout(() => {
        this.loadingController.dismiss()
        //Zu diesem Zeitpunkt hat er dann alle Wifi
      }, 5000);
    });

    this.wifiService.enableLocalLocationAppPermission()
  }

  requestCaptcha() {
    if(this.isHuman == true) return
    this.isHuman = true
    /*
    //Disable sind we are building it new at cloud functions..... 20220725
    let _this = this
    grecaptcha.ready(function () {
      grecaptcha.execute('6Lc6Oh4aAAAAAGI7o_qxTGSWSv2z_JS9VWCB70Sp', { action: 'submit' }).then(function (token) {
        console.log("Captcha Token", token)
        _this.pushService.verifyCaptcha(token).subscribe((val: any) => {
          console.log("Captcha verify", val)
          _this.isHuman = _this.isHuman || val.body.result
          if(_this.isHuman) _this.events.publish('captchaVerified')
        }, err => {
          console.error("Captchat verify failed", err)
          _this.util.presentToast("Leider ist de Captcha Prüfung fehlgeschlagen - vesuche es bitte erneut.", 4000, "toast-warning")
          _this.db.addAnalytics(ANALYTICS_EV_CAPTCHA_ERROR)
        });
      });
    });
    */
  }
}
